import { DEFAULT_CONTENT_TYPE } from '../common/appConstants'


export const accountLevel1ReqBody = (system, accountLevel1Code) => {
  const body = {
    system: system,
    format: DEFAULT_CONTENT_TYPE,
    filter: {
      accountLevel1Code: accountLevel1Code,
      isValidateOnly: true
    }
  }
  return body
}


export const accountLevel2ReqBody = (system, accountLevel1Code, accountLevel2Code) => {
  const body = {
    system: system,
    format: DEFAULT_CONTENT_TYPE,
    filter: {
      accountLevel1Code: accountLevel1Code,
      accountLevel2Code: accountLevel2Code,
      isValidateOnly: true
    }
  }
  return body
}

export const accountLevel3ReqBody = (system, accountLevel1Code, accountLevel2Code, accountLevel3Code) => {
  const body = {
    system: system,
    format: DEFAULT_CONTENT_TYPE,
    filter: {
      accountLevel1Code: accountLevel1Code,
      accountLevel2Code: accountLevel2Code,
      accountLevel3Code: accountLevel3Code,      
      isValidateOnly: false
    }
  }
  return body
}